import React from 'react';
import { Modal } from 'shared/Modal';
import { Button } from 'shared/Button/NewButton';
import { css } from 'emotion';

const UnsupportedFileModal = ({ hideModal }: { hideModal: () => void }) => (
  <Modal
    labelledBy="unsupportedFileModalTitle"
    isShowing={true}
    isShowingCloseButton={true}
    onClickClose={hideModal}
    onClickOutside={hideModal}
    renderContent={() => (
      <div
        className={css`
          text-align: center;
        `}
      >
        <h4
          id="unsupportedFileModalTitle"
          className={css`
            margin-bottom: 16px;
          `}
        >
          Unsupported file
        </h4>
        <p
          className={css`
            margin-bottom: 16px;
          `}
        >
          This file format cannot be uploaded.
        </p>
        <Button color="purple" onClick={hideModal}>
          Got it
        </Button>
      </div>
    )}
  />
);

export { UnsupportedFileModal };
